import { finalize, catchError, map, tap } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from './../../../core/service/base/data.service';
import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { Property } from './../../model/property';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { Observable } from 'rxjs';
import { Company } from '../../model/company';
import { ESignatureErrand } from '../../model/esignature-errand';
import { EsignatureErrandStatus } from '../../model/const/enums';

@Injectable()
export class EsignatureErrandService extends DataService<ESignatureErrand> {
  private readonly _defaultFilterFields: string[] = ['status', 'company', 'errandDescription'];

  constructor(
    httpClient: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(httpClient, config, messageService, ESignatureErrand, progressBar, 'esignature-errand');
  }

  add(model: ESignatureErrand): Observable<any> {
    const formData = new FormData();
    formData.append('jsonData', JSON.stringify(model));
    formData.append('document', model.document, model.document.name);
    this.progressBar.start();
    return this.client.post(this.endpoint, formData).pipe(
      tap(() => this.notification.showSuccess()),
      catchError(error => {
        this.notification.showError(error);
        return [];
      }),
      finalize(() => this.progressBar.stop())
    );
  }

  cancel(id: string): Observable<string | {}> {
    this.progressBar.start();
    return this.client.put<string>(`${this.endpoint}/cancel`, JSON.stringify(id)).pipe(
      catchError(error => {
        this.notification.showError(error);
        throw new Error();
      }),
      tap(() => this.notification.showSuccess('SUCCESS.ESIGN_CANCELLED')),
      finalize(() => this.progressBar.stop())
    );
  }

  download(model: ESignatureErrand): Observable<File> {
    this.progressBar.start();
    return this.getFile(`${this.endpoint}/download-document/${model.id}`, 'document').pipe(
      catchError(error => {
        this.notification.showError(error);
        return [];
      }),
      finalize(() => this.progressBar.stop())
    );
  }

  getFilterDefinition(): Observable<{
    status: number;
    company: string;
    companies: Company[];
    errandDescription: string;
    signatoryName: string;
    signatoryEmail: string;
    signatoryCivicNo: string;
    selectedFields: string[];
    defaultFields: string[];
  }> {
    return this.client.get<any>(`${this.endpoint}/filter`).pipe(
      map(res => {
        return {
          status: res.status ? res.status : 0,
          company: res.company ? res.company : '',
          companies: Array.isArray(res.companies) ? res.companies.map(x => Object.assign(new Company(), x)) : [],
          errandDescription: res.errandDescription ? res.errandDescription : '',
          signatoryName: res.signatoryName,
          signatoryCivicNo: res.signatoryCivicNo,
          signatoryEmail: res.signatoryEmail,
          selectedFields: Array.isArray(res.selectedFields) ? res.selectedFields : this._defaultFilterFields,
          defaultFields: this._defaultFilterFields,
        };
      }),
      catchError(error => {
        console.log(error);
        return [];
      })
    );
  }
}
